import { takeLatest, call, select, put } from 'redux-saga/effects';
import _ from 'lodash';
import axios from '../axiosConfig';
import {
  flightSuccess,
  initDirectSellFlightSearchRequest,
  updateFlightSearchObj,
} from '../../slices/flight';
import { addToTrip } from '../../slices/trip';
import flightSearchInput from '../../../helpers/selectors/flightSearchInput';
import formatDirectFlightSearchRequest from '../../../helpers/formatDirectFlightSegmentRequest';
import { searchSuccess, setFlightTripSearchParam } from '../../slices/tripSearch';
import { SearchStatus } from '../../../constants';
import isValidFlightSegments from '../../../helpers/validationHelpers/isValidFlightSegments';

const queryString = require('query-string');

function* directSellFlightSearchWorker({ payload }) {
  try {
    const { searchInputs } = yield select(flightSearchInput(payload.tripId, payload.isTripSearch));
    const { currencyCode } = yield select((store) => store.tripSearch);
    const flightRateCodes = yield select((store) => store.user.flightRateCodes);

    const { staterooms } = yield select((store) => store.tripSearch.searchInputs);

    if (!payload.isTripSearch && !isValidFlightSegments(searchInputs.flightSegments)) {
      yield put(
        updateFlightSearchObj({
          searchStatus: SearchStatus.DONE,
          tripId: payload.tripId,
        }),
      );
      return;
    }

    let rateSelections = payload?.searchObj?.rateCodes || searchInputs?.rateCodes;
    if (flightRateCodes && flightRateCodes.length && rateSelections === undefined) {
      rateSelections = _.map(
        _.filter(flightRateCodes, (r) => r.isSelectedByDefault),
        (r) => r.selectionKey || r.rateCode,
      );
    }

    const request = {
      ...formatDirectFlightSearchRequest(searchInputs.flightSegments),
      rateCodes: rateSelections?.length ? rateSelections : undefined,
      adults: _.sumBy(staterooms, (s) => s.adults || 0),
      seniors: _.sumBy(staterooms, (s) => s.seniors || 0),
      childrenAge: _.flatMap(staterooms, (s) => Object.values(s.children || {})),
      lapInfants: _.sumBy(staterooms, (s) => s.lapInfants || 0),
      seatInfants: _.sumBy(staterooms, (s) => s.seatInfants || 0),
      currencyCode: currencyCode || undefined,

      doReturnTravelOptions: payload.isTripSearch,
      selectedFlightKey: payload.searchObj?.selectedFlightKey,
      selectedFlightSelectedFareIndex: payload.searchObj?.selectedFlightSelectedFareIndex,
    };

    const searchStatus = payload.doAddSelectedFlightToTrip ? undefined : SearchStatus.SEARCHING;
    if (payload.isTripSearch) {
      yield put(
        setFlightTripSearchParam({
          searchStatus,
          ...searchInputs,
        }),
      );
    } else {
      yield put(
        updateFlightSearchObj({
          searchStatus,
          tripId: payload.tripId,
          ...searchInputs,
        }),
      );
    }

    const query = queryString.stringify(request, { skipNull: true });
    const { data } = yield call(axios, {
      method: 'get',
      url: `/flights/directFlightSearch?${query}`,
    });
    if (payload.isTripSearch) {
      yield put(searchSuccess(data));
    } else {
      yield put(
        flightSuccess({
          queryString: query,
          response: data,
          tripId: payload.tripId,
        }),
      );
    }

    if (payload.doAddSelectedFlightToTrip) {
      let flightItinerary =
        data &&
        data.flightItineraries &&
        data.flightItineraries.length &&
        data.flightItineraries[0].flightKey === payload.flightItinerary.flightKey
          ? data.flightItineraries[0]
          : payload.flightItinerary;
      if (payload.isTripSearch) {
        flightItinerary =
          data &&
          data.travelOptions &&
          data.travelOptions.length &&
          data.travelOptions[0].key === payload.flightItinerary.flightKey
            ? data.travelOptions[0].flightItinerary
            : payload.flightItinerary;
      }
      yield put(
        addToTrip({
          tripId: payload.tripId,
          trip: {
            flightItinerary,
          },
        }),
      );
    }
  } catch (error) {
    console.error('Direct flight search failed:', error);
    if (payload.isTripSearch) {
      yield put(setFlightTripSearchParam({ searchStatus: SearchStatus.DONE }));
    } else {
      yield put(
        updateFlightSearchObj({
          searchStatus: SearchStatus.DONE,
          tripId: payload.tripId,
        }),
      );
    }
  }
}

function* directSellFlightSearchWatcher() {
  yield takeLatest(initDirectSellFlightSearchRequest.toString(), directSellFlightSearchWorker);
}

export default directSellFlightSearchWatcher;
